
const BANK_BIBLE_SHAREPOINT_LINK = 'https://fleetfinancial.sharepoint.com/sites/APPROVALANALYSTTEAM/_layouts/15/Doc.aspx?sourcedoc={0d7e7d86-95a3-47ea-a330-86a42cc8fcdb}&action=embedview&wdAllowInteractivity=False&wdHideGridlines=True&wdHideHeaders=True&wdDownloadButton=True&wdInConfigurator=True&wdInConfigurator=True';

export const ExcelViewer = () => {
  return (
    <div style={{ width: '100%', height: '90vh' }}>
     <iframe width="100%"
        height="100%" src={BANK_BIBLE_SHAREPOINT_LINK}></iframe>
    </div>
  );
};
